import { combineReducers } from 'redux';

import providerSurgeIncentiveSearchForm from './provider-surge-incentive-search-form-reducer';
import providerSurgeIncentiveCreateForm from './provider-surge-incentive-create-form-reducer';
import providerSurgeIncentiveEditForm from './provider-surge-incentive-edit-form-reducer';
import providerSurgeIncentives from './provider-surge-incentives-reducer';
import providerSurgeIncentiveCreate from './provider-surge-incentive-create-request-reducer';
import providerSurgeIncentiveSearchFilters from './provider-surge-incentive-search-filters-reducer';
import providerSurgeIncentiveSearchRequest from './provider-surge-incentive-search-request-reducer';
import providerSurgeIncentiveEditRequest from './provider-surge-incentive-edit-request-reducer';
import flashMessage from './flash-message-reducer';

export default combineReducers({
  searchForm: providerSurgeIncentiveSearchForm,
  createForm: providerSurgeIncentiveCreateForm,
  editForm: providerSurgeIncentiveEditForm,
  incentives: providerSurgeIncentives,
  createRequest: providerSurgeIncentiveCreate,
  searchFilters: providerSurgeIncentiveSearchFilters,
  searchRequest: providerSurgeIncentiveSearchRequest,
  editRequest: providerSurgeIncentiveEditRequest,
  flashMessage
});
